<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $tc('organization', 2) }}</div>
      <div>
        <router-link
          class="btn-blue"
          @click.native="goToRoute('/master/edit-organization')"
          to
        >{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="organizations"
        >{{ $tc('organization', 2) }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>
    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div v-for="(item,index) in Organizations" :key="index" class="col-md-12 py-2">
            <div
              class="row border-bottom"
              v-if="item.fieldname == 'created_at' && GetRoleId && GetRoleId === 1"
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
            </div>
            <div
              class="row border-bottom"
              v-else-if="item.fieldname == 'updated_at' && GetRoleId && GetRoleId === 1"
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
            </div>
            <div class="row border-bottom" v-else-if="item.fieldname == 'org_is_trial'">
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ item.fieldvalue | activeParse }}</div>
            </div>
            <div class="row border-bottom" v-else-if="item.fieldname == 'org_is_active'">
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ item.fieldvalue | activeParse }}</div>
            </div>
            <div
              class="row border-bottom"
              v-else-if="item.fieldname !== 'org_id' && item.fieldname !== 'created_at' && item.fieldname !== 'created_by' && item.fieldname !== 'updated_at' && item.fieldname !== 'updated_by'"
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ item.fieldvalue }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Organizations from "@/helper/formJSONMaster/Organizations";

export default {
  data() {
    return {
      tableId: null,
      Organizations: [
        ...Organizations.organizations,
        {
          fieldname: "created_by",
          fieldkey: "createdby",
          fieldvalue: "123456",
          type: "text"
        },
        {
          fieldname: "created_at",
          fieldkey: "createdat",
          fieldvalue: true,
          type: "text"
        },
        {
          fieldname: "updated_by",
          fieldkey: "modifiedby",
          fieldvalue: true,
          type: "text"
        },
        {
          fieldname: "updated_at",
          fieldkey: "modifiedat",
          fieldvalue: true,
          type: "text"
        }
      ],

      Methods: Organizations.Methods,
      submitted: false,

      // Only get data
      Cities: [],
      CitiesMethod: {
        GET: "/admin/",
        tableName: "ms_cities",
        urlKey: "cities"
      },
      States: [],
      StatesMethod: {
        GET: "/admin/",
        tableName: "ms_states",
        urlKey: "states"
      }
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.tableId = id;
      this.getViewList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    goToRoute: function(path) {
      this.$router.push({
        path: path,
        query: {
          id: this.tableId
        }
      });
    },
    onFocusHandler: function() {
      // this.submitted = false;
    },
    getViewList: function(id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            let obj = data.details[0];
            this.Organizations.map((x, index) => {
              if (x.type === "radio") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? "Yes" : "No";
              }
              if (x.fieldname === "created_by") {
                this.getViewUsersDetails(
                  obj[x.fieldname],
                  index,
                  "Organizations"
                );
              } else if (x.fieldname === "updated_by") {
                this.getViewUsersDetails(
                  obj[x.fieldname],
                  index,
                  "Organizations"
                );
              } else if (x.type === "date") {
                x.fieldvalue = this._formatDate_dd_mm_yyyy(obj[x.fieldname]);
              } else if (x.type === "dropdown") {
                x.fieldvalue = obj[x.fieldname];
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
            this.getCountryList(data.details[0].country_id);
            this.getStatesList(data.details[0].state_id);
            this.getCitiesList(data.details[0].city_id);
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getCountryList: function(uniqueId) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_countries"
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.setNestedDropdownFields("country_id", uniqueId, data.Records);
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    getViewUsersDetails(user_id, index, key) {
      console.log("user_id, index, key :>> ", user_id, index, key);
      this[key][index].fieldvalue = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][index].fieldvalue = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch(error => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    },
    getStatesList: function(uniqueId) {
      this.States = [];
      let body = this.getRequestBody("GET", undefined, this.StatesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.setNestedDropdownFields("state_id", uniqueId, data.Records);
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    getCitiesList: function(uniqueId) {
      this.Cities = [];
      let body = this.getRequestBody("GET", undefined, this.CitiesMethod);
      console.log("body :", body);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.setNestedDropdownFields("city_id", uniqueId, data.Records);
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    setNestedDropdownFields: function(name, id, array) {
      // array
      let filterObj = array.filter(x => x[name] === id);
      console.log("filterObj :", filterObj);
      if (filterObj.length > 0) {
        this.Organizations.map(x => {
          if (name == "country_id" && name === x.fieldname) {
            x.fieldvalue = filterObj[0].country_name;
          } else if (name == "state_id" && name === x.fieldname) {
            x.fieldvalue = filterObj[0].state_name;
          } else if (name == "city_id" && name === x.fieldname) {
            x.fieldvalue = filterObj[0].city_name;
          }
        });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/OrganizationComponents/viewOrganization.vue